import React,{ useReducer,useEffect,useState } from 'react';
import { MainRouter } from './routes/index';
import './App.less';
import "antd/dist/antd.css";
import Header from './modules/home/Header';
import SearchBar from './modules/home/SearchBar';
import Menu from './modules/home/Menu';
import { fetchReducer } from "./store/reducers";
import AxiosTS from './core/axios';

export const XMContext: any = React.createContext(null);
const App: React.FC = (props:any) => {
  const [xmState, xmDispatch] = useReducer(fetchReducer, { login: false, count: 0,firstSubMenuId:"",menuId:"" });
  const [token, setToken] = useState(''); 

  useEffect(() => { 
    AxiosTS.postJSON("eagle/anon/opsigenes/getToken", {})
      .then((res:any) => { 
        if (res.code === '200') { 
          localStorage.setItem("access_token", res.result);
          setToken(res.result);
        }
      })
    
  }, [])

  useEffect(() => { 
    try {
      if (window.getzhiSDKInstance) {
        window.zhiManager = (window.getzhiSDKInstance());
        window.zhiManager.set('customBtn', 'true');
        window.zhiManager.set('color', 'ff9e5d'); //API示例，格式为 0-9 a-f 之间的六位有效字符 不用加#
        window.zhiManager.set('customMargin', 30);
        // zhiManager.set('moduleType', 4);
        window.zhiManager.set('vertical', 50);
        window.zhiManager.on("load", function () {
        });
      }
    }
    catch (err) {
      //在这里处理错误
    }
  })

  return (
    <XMContext.Provider value={{ xmState, dispatch: xmDispatch }}>
    <div className="App" id="app">
      <div className='top'>
        <Header />
        <SearchBar />
      </div>
      <div className='content-box'>
        <div className="center flex">
          <div className='menu'>
              {token && <Menu />}
          </div>
          <div className='content'>
              {token && <MainRouter />}
          </div>
        </div>
        </div>
      </div>
      </XMContext.Provider>
  );
}

export default App;
